import { render, staticRenderFns } from "./HeaderBlock.vue?vue&type=template&id=15a221b5&scoped=true&"
import script from "./HeaderBlock.vue?vue&type=script&lang=ts&"
export * from "./HeaderBlock.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderBlock.vue?vue&type=style&index=0&id=15a221b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a221b5",
  null
  
)

export default component.exports